export default "__VITE_ASSET__DCwmU2ew__"